import { render, staticRenderFns } from "./Gift_TouSu_Dtl.vue?vue&type=template&id=58c358e5&scoped=true"
import script from "./Gift_TouSu_Dtl.vue?vue&type=script&lang=js"
export * from "./Gift_TouSu_Dtl.vue?vue&type=script&lang=js"
import style0 from "./Gift_TouSu_Dtl.vue?vue&type=style&index=0&id=58c358e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c358e5",
  null
  
)

export default component.exports